import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userActions } from "../store/user";
import { useLocation } from "react-router-dom";
import { locationIcon, logoutIcon } from "./Icons";
import logo from "../assets/logo.png";

const Sidebar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/login") {
    return;
  }

  return (
    <>
      <nav className="w-36 h-screen bg-[#343434] pl-4 pr-4 text-lg">
        <NavLink to={"/locations"}>
          <div className="flex flex-col items-center pt-4 pb-4 pl-2 pr-2 cursor-pointer">
            <img src={logo} alt="Logo"/>
            <p className="text-sm pr-1">Dashboard</p>
          </div>
        </NavLink>
        <div className="flex gap-2 h-10 items-center cursor-pointer transition duration-300 ease-in-out hover:text-[#93bfbf]">
          <div className="aspect-square w-6">{locationIcon}</div>
          <NavLink to={"/locations"}>Località</NavLink>
        </div>
        <div className="flex gap-2 h-10 items-center cursor-pointer transition duration-300 ease-in-out hover:text-[#93bfbf]">
          <div className="aspect-square w-6">{logoutIcon}</div>
          <div onClick={() => {dispatch(userActions.logout()); navigate("/login");}}>Logout</div>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
